import { Injectable } from '@angular/core';
import { CommonServiceModule } from 'src/app/common-service/common-service.module';


@Injectable({
    providedIn: CommonServiceModule
})
// tslint:disable-next-line: class-name
export class constantServices {
    // Complainant
    ComplainantTableHeader = ['Complaint Id', 'Complaint Type','Complaint Against', 'Raised Date', 'Status/Action'];
    newComplaint = {
        complaintAgainst: 'Please Enter Complaint Against',
        complaintType: 'Please Enter Complaint Type',
        complaintSub: 'Please Enter Complaint Subject ',
        complaintDes: 'Please Enter Complaint Description',
        facultyName: 'Please Enter Faculty Name'
    };
    // Section Head
    ShtableHeaders = ['Complaint Id', 'Name',  'Complaint Type', 'Complaint Against', 'Created Date', 'Process History', 'Status', 'View'];
    ShassignPopup = {
        roleRequired: 'Please Enter Role',
        personRequired: 'Please Enter Person Name'
    };

    // Section Executive
    SEtableHeaders = ['Complaint Id', 'Name', 'Complaint Type','Complaint Against','Created Date', 'Process History', 'Status', 'Action'];
    semakeAgenda = {
        itemNumber: 'Please Enter ItemNumber',
        itemsub: 'Please Enter Item Subject',
        ltr: 'Please Enter LTR NUmber',
    };
    // Sub Committees
    sctableheaders = ['Agenda Id', 'Agenda Subject', 'Created Date', 'Status'];
    // College
    collegeTable = ['Complaint Id', 'Complaint Type', 'Raised Date', 'Raised By', 'Status']

    seekFormErrors = {
        designation: 'Please Enter Designation',
        person: 'Please Enter Person',
        comments: 'Please Enter comments'
    };
}
export const ConstantServiceModel = [
    constantServices
];
